//react-select component styling object
export const selectStyle = {
    control: (provided, state) => ({
        ...provided,
        border: state.isFocused ? "3px solid #C5C5C5 !important" : "3px solid lightskyblue !important",
        boxShadow: "none",
        borderRadius: "8px",
        fontSize: "1rem",
        width: "375px",
        margin: "15px auto"
    }),
    option: (provided, state) => ({
        ...provided,
        "&:hover": {
            backgroundColor: "#C5C5C5"
        },
        backgroundColor: state.isFocused ? "lightskyblue" : "white",
        color: state.isSelected && "black",
        fontSize: "1rem"
    })
}